<div class="breadcrumb-area">
	<h1>Reportes de Inventarios</h1>
</div>
<div class="card mb-3" id="variousReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==1?0:1">
		<h3>Reportes Varios</h3>
		<h3><i [ngClass]="selectedReport==1?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==1">
		<span class="text-muted"><i class="fa fa-circle-info"></i>La mayoría de los reportes varios necesitan de una
			fecha inicial y una final. Unicamente <em><b>Lista de Precios</b></em> no.</span>
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate" name="startDate" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate" name="endDate" class="form-control">
				</div>
			</div>
		</div>
		<div class="card custom-card" *ngFor="let report of variousReports; let i = index">
			<div class="card-header d-flex justify-content-between align-items-center">
				<h3>{{report.name}}</h3>
				<div class="form-group" *ngIf="report.name=='Saldos de inventarios'">
					<label for="warehouse" class="form-label">Bodega</label>
					<select name="warehouse" [(ngModel)]="warehouse" id="warehouse" class="form-select">
						<option value="0">Todas las bodegas</option>
						<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}
						</option>
					</select>
				</div>
				<div class="col-sm-2 download-buttons">
					<button *ngIf="report.excel" (click)="variousReportDownload(i,'excel')" class="btn btn-success"
						data-bs-toggle="tooltip" title="Descargar Excel"><i *ngIf="!report.downloadexcel"
							class="fa fa-file-excel"></i>
						<span *ngIf="report.downloadexcel" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
					<button *ngIf="report.pdf" (click)="variousReportDownload(i,'pdf')" class="btn btn-primary"
						data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!report.downloadpdf"
							class="fa fa-file-pdf"></i>
						<span *ngIf="report.downloadpdf" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
					<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
							class="fa fa-eye"></i></button>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="emitedInvoicesReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==2?0:2">
		<h3>Reporte de Facturas Emitidas</h3>
		<h3><i [ngClass]="selectedReport==2?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==2">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate2" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate2" name="startDate2" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="endDate2" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate2" name="endDate2" class="form-control">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getInvoiceSalesReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getInvoiceSalesReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="averageDaysExistenceReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==3?0:3">
		<h3>Días Promedio de Existencia Reportes</h3>
		<h3><i [ngClass]="selectedReport==3?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==3">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="date3" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate3" name="date3" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse3" class="form-label">Bodega: </label>
					<select name="warehouse3" [(ngModel)]="warehouse" id="warehouse3" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="type" class="form-label">Tipo: </label>
					<select name="type" [(ngModel)]="typeInv" id="type" class="form-select">
						<option label="Todos" value="" selected="selected">Todos</option>
						<option label="Materia Prima" value="m">Materia Prima</option>
						<option label="Producto en Proceso" value="p">Producto en Proceso</option>
						<option label="Producto Terminado" value="t">Producto Terminado</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterDayReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterDayReport" placeholder="Bodega, producto, código o precio"
						name="filterDayReport" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getAverageDaysExistenceReport('excel')"
					data-bs-toggle="tooltip" title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getAverageDaysExistenceReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="existenceReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="showExistenceReport()">
		<h3>Control de Existencias y Reportería</h3>
		<h3><i [ngClass]="selectedReport==4?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==4">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="date4" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="date4" name="date4" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse" class="form-label">Bodega: </label>
					<select
						name="existenceWarehouse"
						[(ngModel)]="existenceWarehouse"
						id="existenceWarehouse"
						class="form-select"
						>
						<option [ngValue]="0">Todas</option>

						<option
							*ngFor="let w of warehouses"
							[ngValue]="w.id">
							{{ w.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="type4" class="form-label">Tipo: </label>
					<select name="type4" [(ngModel)]="typeInv" id="type4" class="form-select">
						<option label="Todos" value="" selected="selected">Todos</option>
						<option label="Materia Prima" value="m">Materia Prima</option>
						<option label="Producto en Proceso" value="p">Producto en Proceso</option>
						<option label="Producto Terminado" value="t">Producto Terminado</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label class="form-label">Producto:</label>

					<app-input-autocomplete
						[allBorderRadius]="true"
						[inputs]="inputsExistence.product"
						[placeholder]="'Código o nombre de producto'"
						[filterElements]="existenceProductFilter"
						[typeElements]="'productExistence'"
						(inputMethod)="writeExistenceProduct($event.event)"
						[custom]="true"
						(changeStatus)="selectExistenceProduct($event.filterElement)">

						<ng-template #itemsTemplate let-filter>
							<div class="field">

								<span class="val-span">
									{{ filter.name }}
								</span>

								<span class="field-span">
									<b>
										<i class="fa fa-barcode"></i>
									</b>

									{{ filter.barCode }}

									<i
										class="fa fa-question"
										style="opacity: 0.8;"
										*ngIf="!filter.barCode">
									</i>

									<b style="margin-left: 1rem;">
										<i class="fa fa-key"></i>
									</b>

									{{ filter.code }}

									<i
										class="fa fa-question"
										style="opacity: 0.8;"
										*ngIf="!filter.code">
									</i>
								</span>

							</div>
						</ng-template>

					</app-input-autocomplete>
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getExistenceInventoryReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getExistenceInventoryReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte" (click)="getExistenceInventoryReport('json')"><i
						class="fa fa-eye"></i></button>
			</div>
			</div>
			

<div
  class="mt-4"
  *ngIf="existenceReportRows.length > 0">

  <div class="mb-2 text-muted">
    Productos encontrados:
    <strong>{{ existenceReportRows.length }}</strong>
  </div>

  <div class="table-responsive">

    <table class="table table-striped table-bordered
                  table-hover align-middle">

      <thead>
        <tr>
          <th>Código</th>
          <th>Nombre</th>
		  <th>Familia</th>

          <th
            class="text-center"
            *ngFor="let warehouse of existenceReportWarehouses">
            {{ warehouse }}
          </th>

          <th class="text-center">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let product of existenceReportRows">

          <td>{{ product.productCode }}</td>

          <td>{{ product.productName }}</td>

		  <td>{{ product.productCategoryName }}</td>

          <td
            class="text-center"
            *ngFor="let warehouse of existenceReportWarehouses">
            {{ product.warehouses[warehouse] ?? 0 }}
          </td>

          <td class="text-center fw-bold">
            {{ product.total }}
          </td>

        </tr>
      </tbody>

    </table>

  </div>
</div>



		<div
			*ngIf="
				existenceReportData &&
				existenceReportData.length === 0
			"
			class="text-center mt-4 text-muted">

			<i class="fa fa-circle-info"></i>
			No se encontraron resultados

		</div>
	</div>
</div>

<div class="card mb-3" id="entryReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==5?0:5">
		<h3>Control de Entradas y Reportería</h3>
		<h3><i [ngClass]="selectedReport==5?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==5">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate5" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate5" name="startDate5" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate5" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate5" name="endDate5" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse5" class="form-label">Bodega: </label>
					<select name="warehouse5" [(ngModel)]="warehouse" id="warehouse5" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="type5" class="form-label">Tipo: </label>
					<select name="type5" [(ngModel)]="typeInv" id="type5" class="form-select">
						<option label="Todos" value="" selected="selected">Todos</option>
						<option label="Materia Prima" value="m">Materia Prima</option>
						<option label="Producto en Proceso" value="p">Producto en Proceso</option>
						<option label="Producto Terminado" value="t">Producto Terminado</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterEntryReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterEntryReport" placeholder="Bodega, producto, código o precio"
						name="filterEntryReport" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getEntryReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getEntryReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="kardexReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showReport(6)">
		<h3>Kardex y Reportería</h3>
		<h3><i [ngClass]="selectedReport==6?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==6">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate6" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate6" name="startDate6" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate6" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate6" name="endDate6" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="productKardex-input" class="form-label">Producto: </label>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productKardex"
							[placeholder]="'Código o nombre de producto'" [filterElements]="productFilter"
							[typeElements]="'productKardex'" (inputMethod)="writeProductKardex($event.event)"
							[custom]="true" (changeStatus)="selectProduct($event.filterElement)">
							<ng-template #itemsTemplate let-filter>
								<div class="field">
									<span class="val-span">{{filter.name}}</span>
									<span class="field-span">
										<b>
											<i class="fa fa-barcode"></i>
										</b>
										{{filter.barCode}}
										<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.barCode"></i>
										<b style="margin-left: 1rem;">
											<i class="fa fa-key"></i>
										</b>
										{{filter.code}}
										<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.code"></i>
									</span>
								</div>
							</ng-template>
						</app-input-autocomplete>
					</div>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse6" class="form-label">Bodega: </label>
					<select name="warehouse6" [(ngModel)]="warehouse" id="warehouse6" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" [disabled]="!productSelected" (click)="getCardexReport('excel')"
					data-bs-toggle="tooltip" title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" [disabled]="!productSelected" (click)="getCardexReport('pdf')"
					data-bs-toggle="tooltip" title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" [disabled]="!productSelected" (click)="getCardexReport('json')"
					data-bs-toggle="tooltip" title="Ver Reporte"><i class="fa fa-eye"></i></button>
			</div>
		</div>

		<ng-container *ngIf="kardex">
			<div class="input-group mt-3">
				<label for="filterKardexReport" class="input-group-text"><i class="fa fa-search"></i></label>
				<input type="text" (input)="filterKardex()" id="filterKardexReport"
					placeholder="Unidades, Costo, Documento" name="filterKardexReport" [(ngModel)]="searchKardex"
					class="form-control">
			</div>
			<div class="kardex-data" style="padding-top: 1em;">
				<span>
					<i class="fa fa-key subtitle"></i> <b>{{kardex?.productCode}}</b>
				</span>
				<span>
					<i class="fa fa-box subtitle"></i> <b>{{kardex?.productName}}</b>
				</span>
				<span>
					<i class="fa fa-building subtitle"></i> <b>{{kardex?.warehouseName}}</b>
				</span>
				<span>
					<i class="fa fa-calendar-days subtitle"></i> <span class="subtitle">De </span>
					<b>{{kardex?.startDate}}</b> <span class="subtitle">hasta</span> <b>{{kardex?.endDate}}</b>
				</span>
			</div>
		</ng-container>
		<p *ngIf="kardex?.entries.length === 0" class="display-5 text-center">
			<i class="fa fa-circle-info"></i>No se encontraron resultados
		</p>
		<ng-container *ngIf="paginationKardex.filter.length > 0">
			<div class="table-responsive" style="margin-bottom: 0;">
				<table class="table table-striped" style="margin-bottom: 0;">
					<thead>
						<tr class="tr-middle">
							<th rowspan="2">
								Fecha
							</th>
							<th rowspan="2">
								Documento
							</th>
							<th colspan="3">
								Entradas
							</th>
							<th colspan="3">
								Salidas
							</th>
							<th colspan="3">
								Existencias
							</th>
						</tr>
						<tr class="tr-middle">
							<th>
								Unidades
							</th>
							<th class="text-end">
								Costo Unitario
							</th>
							<th class="text-end">
								Costo Total
							</th>
							<th>
								Unidades
							</th>
							<th class="text-end">
								Costo Unitario
							</th>
							<th class="text-end">
								Costo Total
							</th>
							<th>
								Unidades
							</th>
							<th class="text-end">
								Costo Unitario
							</th>
							<th class="text-end">
								Costo Total
							</th>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let cardex of paginationKardex.filter">
							<tr>
								<td class="kardex-border kardex-border">
									<span *ngIf="cardex.type != null">
										{{cardex.date | date : 'dd/MM/yyyy'}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type == null">--</span>
								</td>
								<td class="kardex-border kardex-border">
									<span *ngIf="cardex.type != null">
										{{cardex.document}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type == null">--</span>
								</td>
								<td class="kardex-border kardex-border" style="text-align: center;">
									<span *ngIf="cardex.type == 1">
										{{cardex.quantity}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type != 1">--</span>
								</td>
								<td class="td-table-for-currency kardex-border text-end">
									<span *ngIf="cardex.type == 1">
										{{cardex.unitCost | currency: 'Q'}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type != 1">--</span>
								</td>
								<td class="td-table-for-currency kardex-border text-end">
									<span *ngIf="cardex.type == 1">
										{{cardex.totalCost | currency: 'Q'}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type != 1">--</span>
								</td>
								<td class="kardex-border" style="text-align: center;">
									<span *ngIf="cardex.type == 2">
										{{cardex.quantity}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type != 2">--</span>
								</td>
								<td class="td-table-for-currency kardex-border text-end">
									<span *ngIf="cardex.type == 2">
										{{cardex.unitCost | currency: 'Q'}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type != 2">--</span>
								</td>
								<td class="td-table-for-currency kardex-border text-end">
									<span *ngIf="cardex.type == 2">
										{{ cardex.totalCost | currency: 'Q'}}
									</span>
									<span class="text-info" style="opacity: 0.7;" *ngIf="cardex.type != 2">--</span>
								</td>
								<td class="kardex-border" style="text-align: center;">
									{{cardex.existence}}</td>
								<td class="td-table-for-currency kardex-border text-end">
									{{cardex.existenceUnitCost | currency: 'Q'}}</td>
								<td class="td-table-for-currency kardex-border text-end">
									{{cardex.existenceTotalCost | currency: 'Q'}}</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>
			<app-pagination-custom [elements]="paginationKardex"></app-pagination-custom>
		</ng-container>
	</div>
</div>

<div class="card mb-3" id="stationReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==7?0:7">
		<h3>Reportería y Estacionalidad</h3>
		<h3><i [ngClass]="selectedReport==7?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==7">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="month7" class="form-label">Mes: </label>
					<select name="month7" [(ngModel)]="month" id="month7" class="form-select">
						<option label="Enero" value="1">Enero</option>
						<option label="Febrero" value="2">Febrero</option>
						<option label="Marzo" value="3">Marzo</option>
						<option label="Abril" value="4">Abril</option>
						<option label="Mayo" value="5">Mayo</option>
						<option label="Junio" value="6">Junio</option>
						<option label="Julio" value="7">Julio</option>
						<option label="Agosto" value="8">Agosto</option>
						<option label="Septiembre" value="9">Septiembre</option>
						<option label="Octubre" value="10">Octubre</option>
						<option label="Noviembre" value="11">Noviembre</option>
						<option label="Diciembre" value="12">Diciembre</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="year7" class="form-label">Mes: </label>
					<select name="year7" id="year7" [(ngModel)]="year" class="form-select">
						<option *ngFor="let y of years" label="{{y}}" value="{{y}}">{{y}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse7" class="form-label">Bodega: </label>
					<select name="warehouse7" [(ngModel)]="warehouse" id="warehouse7" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterStationReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterStationReport" placeholder="Bodega, producto, código o precio"
						name="filterStationReport" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getSeasonalityReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getSeasonalityReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="utilityReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showReport(8)">
		<h3>Margen de Utilidad y Reportería</h3>
		<h3><i [ngClass]="selectedReport==8?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==8">
		<div class="row mb-3">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate8" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate8" name="startDate8" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate8" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate8" name="endDate8" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="productUtility-input" class="form-label">Producto: </label>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productKardex"
							[placeholder]="'Código o nombre de producto'" [filterElements]="productFilter"
							[typeElements]="'productUtility'" (inputMethod)="writeProductKardex($event.event)"
							(getTitle)="$event.filterElement.title = $event.filterElement.name"
							(changeStatus)="selectProduct($event.filterElement)"></app-input-autocomplete>
					</div>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse8" class="form-label">Bodega: </label>
					<select name="warehouse8" [(ngModel)]="warehouse" id="warehouse8" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterStationReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterStationReport" placeholder="Bodega, producto, código o precio"
						name="filterStationReport" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons align-items-end">
				<button class="btn btn-success" (click)="getProfitMarginReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getProfitMarginReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" (click)="getProfitMarginReportJson()" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
		<div class="row mb-3">
			<app-profit-margin-report-preview [data]="prifitMarfinReportData"></app-profit-margin-report-preview>
			<!-- <app-pagination-custom [elements]="paginationProfitMargin"></app-pagination-custom> -->
		</div>
	</div>
</div>

<div class="card mb-3" id="utilityByClientReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showReport(9)">
		<h3>Margen de Utilidad por Cliente y Reportería</h3>
		<h3><i [ngClass]="selectedReport==9?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==9">
		<div class="row">
			<div class="col-sm-10">
				<div class="row">
					<div class="col-sm">
						<div class="form-group">
							<label for="startDate9" class="form-label">Fecha Inicial:</label>
							<input type="date" [(ngModel)]="startDate" id="startDate9" name="startDate9"
								class="form-control">
						</div>
					</div>
					<div class="col-sm">
						<div class="form-group">
							<label for="endDate9" class="form-label">Fecha Final:</label>
							<input type="date" [(ngModel)]="endDate" id="endDate9" name="endDate9" class="form-control">
						</div>
					</div>
					<div class="col-sm">
						<div class="form-group">
							<label for="client9" class="form-label">Cliente: </label>
							<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.client"
								[placeholder]="'Nit o nombre del cliente'" [filterElements]="clientFilter"
								[typeElements]="'productUtilityByClient'" (inputMethod)="writeClient($event.event)"
								(getTitle)="$event.filterElement.title = $event.filterElement.nit + ' - '+ $event.filterElement.name"
								(changeStatus)="selectClient($event.filterElement)"></app-input-autocomplete>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm">
						<div class="form-group">
							<label for="productUtilityByClient-input" class="form-label">Producto: </label>
							<div class="input-group input-group-sm">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productKardex"
									[placeholder]="'Código o nombre de producto'" [filterElements]="productFilter"
									[typeElements]="'productUtilityByClient'"
									(inputMethod)="writeProductKardex($event.event)"
									(getTitle)="$event.filterElement.title = $event.filterElement.name"
									(changeStatus)="selectProduct($event.filterElement)"></app-input-autocomplete>
							</div>
						</div>
					</div>
					<div class="col-sm">
						<div class="form-group">
							<label for="warehouse9" class="form-label">Bodega: </label>
							<select name="warehouse9" [(ngModel)]="warehouse" id="warehouse9" class="form-select">
								<option value="">Todas</option>
								<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
							</select>
						</div>
					</div>
					<div class="col-sm">
						<div class="form-group">
							<label for="filterUtilityClientReport" class="form-label">Búsqueda</label>
							<input type="text" id="filterUtilityClientReport"
								placeholder="Bodega, producto, código o precio" name="filterUtilityClientReport"
								class="form-control">
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-2" style="display: flex;">
				<div class="col-sm download-buttons">
					<button class="btn btn-success" (click)="getProfitMarginByClientReport('excel')"
						data-bs-toggle="tooltip" title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
					<button class="btn btn-primary" (click)="getProfitMarginByClientReport('pdf')"
						data-bs-toggle="tooltip" title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
					<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
							class="fa fa-eye"></i></button>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="transformReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==10?0:10">
		<h3>Reportería de transferencias y transformaciones</h3>
		<h3><i [ngClass]="selectedReport==10?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==10">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate10" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate10" name="startDate10" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate10" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate10" name="endDate10" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse10" class="form-label">Bodega: </label>
					<select name="warehouse10" [(ngModel)]="warehouse" id="warehouse10" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterTransformReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterTransformReport" placeholder="Bodega, producto, código o precio"
						name="filterTransformReport" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getTransformReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getTransformReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="inventoryDataAssociatedReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==11?0:11">
		<h3>Reporte de Inventarios Asociados</h3>
		<h3><i [ngClass]="selectedReport==11?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==11">
		<div class="row">
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getInventoryAssociatedReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="transformReport" [appCheckPermission]="[5053]" [permissionType]="permissionType.ALL">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==12?0:12">
		<h3>Información de Bolsa de Facturas</h3>
		<h3><i [ngClass]="selectedReport==12?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==12">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate12" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate12" name="startDate12" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate12" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate12" name="endDate12" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getProjectDataReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="notAssociatedProductsReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center">
		<h3>Reporte de Productos no asociados</h3>
		<app-loading-button data-bs-toggle="tooltip" title="Descargar Excel" [object]="btnNotAssociatedProducts"
			(clicked)="getNotAssociatedProducts('excel')"></app-loading-button>
	</div>
</div>
<div class="card mb-3" id="notAssociatedProductsReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==13?0:13">
		<h3>PDF Realización de productos</h3>
		<h3><i [ngClass]="selectedReport==13?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==13">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate13" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate13" name="startDate13" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate13" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate13" name="endDate13" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse13" class="form-label">Bodega: </label>
					<select name="warehouse13" [(ngModel)]="warehouse" id="warehouse13" class="form-select">
						<option *ngFor="let w of warehouses" [ngValue]="w.id">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm download-buttons" style="justify-content: center;">
				<button class="btn btn-primary" (click)="getAuditInventory()" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="moveInventoryReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showReport(14)">
		<h3>Movimiento Inventario</h3>
		<h3><i [ngClass]="selectedReport==14?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==14">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate14" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate14" name="startDate14" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate13" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate14" name="endDate14" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<app-input-autocomplete-selection 
            [inputs]="inputsProduct.product" 
            [placeholder]="'Ingresa id o nombre de un producto'"
            [filterElements]="productFilter" 
            [typeElements]="'product'"
            [enableSelect]="true" 
            (inputMethod)="handleInput($event.event, 'product')"
            (changeMethod)="verifiedInput($event.event, 'product')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'product')"
            (getTitle)="
                $event.filterElement.title = 
                (($event.filterElement.code) ? $event.filterElement.code + ' - ' : '') + 
                $event.filterElement.name
            ">
            </app-input-autocomplete-selection>
			</div>
			<div class="col-sm download-buttons" style="justify-content: center;">
				<app-loading-button data-bs-toggle="tooltip" title="Descargar Excel" [object]="btnMoveInventory"
						(clicked)="getMoveInventory('excel')"></app-loading-button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="moveInventoryReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showReport(15)">
		<h3>Conjunto de Familias de Producto</h3>
		<h3><i [ngClass]="selectedReport==15?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==15">
		<div class="row">
			<div class="col-sm download-buttons" style="justify-content: center;">
				<app-loading-button data-bs-toggle="tooltip" title="Descargar Excel" [object]="btnFamilies"
						(clicked)="getFamiliesReport('excel')"></app-loading-button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="moveInventoryReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showReport(16)">
		<h3>Estacionalidad General</h3>
		<h3><i [ngClass]="selectedReport==16?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==16">
		<div class="row">
			<div class="col-sm">
			<div class="form-group">
				<label for="yearInput" class="form-label">Año:</label>
				<input
				id="yearInput"
				class="form-control"
				type="number"
				min="2000"
				max="2100"
				[(ngModel)]="yearSeason"
				placeholder="Año"
				/>
			</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="warehouse3" class="form-label">Bodega: </label>
					<select name="warehouse3" [(ngModel)]="warehouse" id="warehouse3" class="form-select">
						<option value="">Todas</option>
						<option *ngFor="let w of warehouses" value="{{w.id}}">{{w.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<app-input-autocomplete-selection 
            [inputs]="inputsProduct.product" 
            [placeholder]="'Ingresa id o nombre de un producto'"
            [filterElements]="productFilter" 
            [typeElements]="'product'"
            [enableSelect]="true" 
            (inputMethod)="handleInput($event.event, 'product')"
            (changeMethod)="verifiedInput($event.event, 'product')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'product')"
            (getTitle)="
                $event.filterElement.title = 
                (($event.filterElement.code) ? $event.filterElement.code + ' - ' : '') + 
                $event.filterElement.name
            ">
            </app-input-autocomplete-selection>
			</div>
			<div class="col-sm download-buttons" style="justify-content: center;">
				<app-loading-button data-bs-toggle="tooltip" title="Descargar Excel" [object]="btnSeasonality"
						(clicked)="getGeneralSeasonalityProduct('excel')"></app-loading-button>
			</div>
		</div>
	</div>
</div>